<div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
  <div class="col-md-11 body-class">
    <h1>Gestion des sociétés</h1>
  </div>
  <div class="col-md-1 body-class" style="padding-top: 15px;">
    <button class="pull-right" color="warn" mat-raised-button type="button" (click)="onLeave()">
      <mat-icon>cancel</mat-icon> Fermer
    </button>
  </div>
</div>
<div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
  <div class="col-md-8">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Rechercher une société</mat-label>
      <input matInput [(ngModel)]="objet.query" (change)="search()" (keydown.enter)="search()" placeholder="Code, libelle de la société">
    </mat-form-field>
  </div>
  <div class="col-md-1 top">
    <button type="button" mat-raised-button color="primary" (click)="onCreate()" mat-icon-button><mat-icon>add</mat-icon></button>
  </div>
  <div class="col-md-1 top">
    <button mat-raised-button color="primary" type="button" (click)="search()" style="color: white;"mat-icon-button><mat-icon>search</mat-icon></button>
  </div>
</div>  
<div class="col-md-12">
  <div class="mat-table">
    <div class="table_principale">
      <table mat-table matSort [dataSource]="matDataSource" multiTemplateDataRows class="mat-elevation-z8" (matSortChange)="sortData($event)" matSortActive="code">
        <caption>Liste des sociétés</caption>
        <ng-container matColumnDef="code">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Code </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> {{element.code}} </td>
        </ng-container>
    
        <ng-container matColumnDef="libelle">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Libellé </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.libelle}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="capitalSocial">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Capital social </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.capitalSocial}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="rsc">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> RCS </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.rsc}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="siren">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> SIREN </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.siren}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="tvaIntraComm">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> TVA intra communautaire </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.tvaIntraComm}}</div> </td>
        </ng-container>
    
        <ng-container matColumnDef="activite">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Activité </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.activite.code}} {{element.activite.libelle}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element" style="padding: 0;">
            <div class="center">
              <span *ngIf="element.agenceId !== null" (click)="onDelete(element)">
                <mat-icon class="red-icon">close</mat-icon>
              </span>
            </div>
          </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns, sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
      </table>
    
      <div class="footer">
        <mat-paginator
          #paginator
          [length]="length"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 25, 50]"
          (page)="changePage($event)">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
